import axios from "axios";
import { BASE_URL } from "App/constants";

export const getGeminiPromptsList = async (searchQuery?: string) => {
  const searchParam = searchQuery
    ? `search_query=${encodeURIComponent(searchQuery)}`
    : "";
  const { data } = await axios.get(`${BASE_URL}gemini_prompts?${searchParam}`);
  if (data) {
    return data;
  }
  return { prompts: [], total_count: 0 };
};

export const updateGeminiPrompt = async (
  id: number,
  payload: { prompt: string }
) => {
  const { data } = await axios.patch(`${BASE_URL}gemini_prompts/${id}`, {
    gemini_prompt: payload,
  });
  return data;
};

export const createGeminiPrompt = async (payload: {
  prompt: string;
  master_sport_id: number;
}) => {
  const { data } = await axios.post(`${BASE_URL}gemini_prompts`, {
    gemini_prompt: payload,
  });
  return data;
};

export const getMasterSportsExcluding = async (
  excludeMasterSportIds: number[]
) => {
  const excludeParam =
    excludeMasterSportIds.length > 0
      ? `?exclude_master_sport_ids=${excludeMasterSportIds.join(",")}`
      : "";
  const { data } = await axios.get(`${BASE_URL}master_sports${excludeParam}`);
  if (data) {
    return data;
  }
  return [];
};
